import React, { useEffect, useState } from "react";
import { FormatMoney } from "../../../Helpers/FormatNumber";
import Swal from "sweetalert2";
import request from "../../../Helpers/API";
 
const MdlSolicitudCreditoScreen = ({ folio, setLoader, loader }) => {
  const [solicitud, setSolicitud] = useState({});
 
  useEffect(() => {
    setLoader({ ...loader, mostrar: true });
    request
      .get(`ACSolicitud/Listado?folio=${folio}`)
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        setSolicitud(result);
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("ANALISIS CREDITO", JSON.stringify(error), "error");
      });
  }, []);
  return (
    <div className="analisis-as-screen">
      <div className="analisis-as-screen-group">
        Folio:
        <div>{solicitud.folio}</div>
      </div>
      <div className="analisis-as-screen-group">
        Cliente:
        <div>{solicitud.cliente}</div>
      </div>
      <div className="analisis-as-screen-group">
        Sucursal:
        <div>{solicitud.sucursal}</div>
      </div>
      <div className="analisis-as-screen-group">
        Vendedor:
        <div>{solicitud.vendedor}</div>
      </div>
      <div className="analisis-as-screen-group">
        Fecha:
        <div>{solicitud.fecha_creacion}</div>
      </div>
      <div className="analisis-as-screen-group">
        Tipo de solicitud:
        <div>{solicitud.tipo_solicitud}</div>
      </div>
      <div className="analisis-as-screen-group">
        Linea de credito:
        <div>{solicitud.linea_credito}</div>
      </div>
      <div className="analisis-as-screen-group">
        Nivel de riesgo:
        <div>{solicitud.nivel_riesgo}</div>
      </div>
      <div className="analisis-as-screen-group">
        Responsable:
        <div>{solicitud.responsable_credito}</div>
      </div>
      <div className="analisis-as-screen-group">
        Estatus:
        <div>{solicitud.estado}</div>
      </div>
      <div className="analisis-as-screen-group">
        Monto:
        <div>$ {FormatMoney(solicitud.importe)}</div>
      </div>
    </div>
  );
};
 
export default MdlSolicitudCreditoScreen;
 
 